import React from 'react'
import { Link } from 'react-router-dom'
import './Partners.css'

const Partners = () => {
  return (
    <div className='partners-page'>
      {/* Page Header */}
      <section className='page-header'>
        <div className='hero-background'>
          <img
            src='https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80'
            alt='Partners Hero Background'
          />
          <div className='hero-overlay'></div>
        </div>
        <div className='container'>
          <h1>Our Strategic Partners</h1>
          <p>
            Trusted partnerships with leading global technology brands to
            deliver cutting-edge solutions
          </p>
        </div>
      </section>

      {/* Partners Overview */}
      <section className='partners-overview'>
        <div className='container'>
          <div className='partners-intro'>
            <h2>Why Strategic Partnerships Matter</h2>
            <p>
              TecMates has access to cutting-edge technologies and support
              through our strategic alliances. These partnerships enhance our
              ability to deliver innovative solutions that meet the diverse
              needs of the IT community. We are proud to be authorized business
              partners of leading global technology brands, ensuring
              performance, scalability, and security for our clients.
            </p>
          </div>
        </div>
      </section>

      {/* Partners Grid */}
      <section className='partners-detailed'>
        <div className='container'>
          <h2 className='section-title'>Our Technology Partners</h2>
          <p className='section-subtitle'>
            Authorized partners of leading global technology brands
          </p>

          <div className='partners-grid-detailed'>
            <div className='partner-card'>
              <div
                className='partner--logo-large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/acer.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Computing Solutions</h4>
                <p>
                  Leading manufacturer of desktops, laptops, and computing
                  solutions for business and enterprise environments.
                </p>
                <ul>
                  <li>Business laptops and desktops</li>
                  <li>Workstation solutions</li>
                  <li>Server infrastructure</li>
                  <li>Professional displays</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner--logo-large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/hpe.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Enterprise Infrastructure</h4>
                <p>
                  Global leader in enterprise technology solutions, providing
                  servers, storage, and networking infrastructure.
                </p>
                <ul>
                  <li>Enterprise servers</li>
                  <li>Storage solutions</li>
                  <li>Networking equipment</li>
                  <li>Cloud infrastructure</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner--logo-large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/peoplelink.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Communication Solutions</h4>
                <p>
                  Specialized in unified communication and collaboration
                  solutions for modern enterprises.
                </p>
                <ul>
                  <li>Video conferencing</li>
                  <li>Unified communications</li>
                  <li>Collaboration tools</li>
                  <li>Meeting room solutions</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='108'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                  }}
                  src='./images/molex.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Connectivity Solutions</h4>
                <p>
                  Global leader in electronic solutions, providing high-quality
                  connectors and connectivity products.
                </p>
                <ul>
                  <li>Data center connectivity</li>
                  <li>Network cabling</li>
                  <li>Industrial solutions</li>
                  <li>Custom connectors</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='108'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                  }}
                  src='./images/dlink.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Networking Equipment</h4>
                <p>
                  Leading provider of networking solutions for home, business,
                  and enterprise environments.
                </p>
                <ul>
                  <li>Network switches</li>
                  <li>Wireless access points</li>
                  <li>Network security</li>
                  <li>IoT solutions</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/techroutes.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Network Solutions</h4>
                <p>
                  Specialized in advanced networking and routing solutions for
                  enterprise environments.
                </p>
                <ul>
                  <li>SD-WAN solutions</li>
                  <li>Network routing</li>
                  <li>Traffic management</li>
                  <li>Network optimization</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/aruba.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Wireless & Security</h4>
                <p>
                  Hewlett Packard Enterprise company specializing in wireless
                  networking and security solutions.
                </p>
                <ul>
                  <li>Wireless networking</li>
                  <li>Network security</li>
                  <li>Location services</li>
                  <li>Network management</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                {/* <h3>Systrome</h3> */}
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/systrome.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>System Integration</h4>
                <p>
                  Specialized in system integration and custom technology
                  solutions for enterprise clients.
                </p>
                <ul>
                  <li>System integration</li>
                  <li>Custom solutions</li>
                  <li>Legacy modernization</li>
                  <li>Technical consulting</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                {/* <h3>Matrix</h3> */}
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/matrix.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Security & Communication</h4>
                <p>
                  Leading provider of security and communication solutions for
                  enterprise environments.
                </p>
                <ul>
                  <li>Security systems</li>
                  <li>Communication solutions</li>
                  <li>Access control</li>
                  <li>Surveillance systems</li>
                </ul>
              </div>
            </div>

            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                {/* <h3>Vantageo</h3> */}
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/vantageo.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Advanced Technology</h4>
                <p>
                  Provider of advanced technology solutions and innovative
                  products for modern enterprises.
                </p>
                <ul>
                  <li>Advanced technology</li>
                  <li>Innovation solutions</li>
                  <li>Custom development</li>
                  <li>Technology consulting</li>
                </ul>
              </div>
            </div>
            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                {/* <h3>Vantageo</h3> */}
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                    padding: '2rem',
                    paddingBottom: '1rem',
                  }}
                  src='./images/hp.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Computing Solutions</h4>
                <p>
                  Global provider of innovative desktops, laptops, and
                  enterprise technology that drive productivity, security, and
                  sustainability.
                </p>
                <ul>
                  <li>Business Laptops & Desktops</li>
                  <li>High-Performance Workstations</li>
                  <li>Enterprise Servers & IT Infrastructure</li>
                  <li>Professional Displays & Accessories</li>
                </ul>
              </div>
            </div>
            <div className='partner-card'>
              <div
                className='partner-logo--large'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.09)' }}
              >
                {/* <h3>Vantageo</h3> */}
                <img
                  width='150'
                  style={{
                    objectFit: 'contain',
                    display: 'flex',
                    marginLeft: '2rem',
                  }}
                  src='./images/vertivlogo.png'
                  alt='#'
                />
              </div>
              <div className='partner-info'>
                <h4>Power & Infrastructure</h4>
                <p>
                  Global provider of reliable power, cooling, and digital
                  infrastructure solutions for enterprises, data centers, and
                  industries.
                </p>
                <ul>
                  <li>UPS & Power Distribution</li>
                  <li>Precision Cooling Systems</li>
                  <li>Smart Racks & Enclosures</li>
                  <li>Infrastructure Monitoring & Management</li>
                  <li>Edge & Data Center Solutions</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Benefits */}
      <section className='partnership-benefits'>
        <div className='container'>
          <h2 className='section-title'>Benefits of Our Partnerships</h2>
          <p className='section-subtitle'>
            How our strategic partnerships benefit our clients
          </p>

          <div className='benefits-grid'>
            <div className='benefit-item'>
              <div className='benefit-icon'>
                <i className='fas fa-tools'></i>
              </div>
              <h3>Authorized Support</h3>
              <p>
                Direct access to manufacturer support and warranty services for
                all partner products.
              </p>
            </div>

            <div className='benefit-item'>
              <div className='benefit-icon'>
                <i className='fas fa-certificate'></i>
              </div>
              <h3>Certified Expertise</h3>
              <p>
                Our team is certified and trained on partner technologies to
                provide expert implementation.
              </p>
            </div>

            <div className='benefit-item'>
              <div className='benefit-icon'>
                <i className='fas fa-dollar-sign'></i>
              </div>
              <h3>Competitive Pricing</h3>
              <p>
                Access to partner pricing and volume discounts to provide
                cost-effective solutions.
              </p>
            </div>

            <div className='benefit-item'>
              <div className='benefit-icon'>
                <i className='fas fa-rocket'></i>
              </div>
              <h3>Latest Technology</h3>
              <p>
                Early access to new products and technologies from our strategic
                partners.
              </p>
            </div>

            <div className='benefit-item'>
              <div className='benefit-icon'>
                <i className='fas fa-headset'></i>
              </div>
              <h3>Technical Support</h3>
              <p>
                Direct technical support and escalation channels with partner
                engineering teams.
              </p>
            </div>

            <div className='benefit-item'>
              <div className='benefit-icon'>
                <i className='fas fa-shield-alt'></i>
              </div>
              <h3>Quality Assurance</h3>
              <p>
                Genuine products with full warranty coverage and quality
                assurance from manufacturers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Process */}
      <section className='partnership-process'>
        <div className='container'>
          <h2 className='section-title'>Our Partnership Process</h2>
          <p className='section-subtitle'>
            How we work with our partners to deliver the best solutions
          </p>

          <div className='process-grid'>
            <div className='process-step'>
              <div className='step-number'>1</div>
              <h3>Assessment</h3>
              <p>
                We assess your business needs and identify the most suitable
                partner solutions for your requirements.
              </p>
            </div>

            <div className='process-step'>
              <div className='step-number'>2</div>
              <h3>Solution Design</h3>
              <p>
                Our certified team designs comprehensive solutions using the
                best partner technologies.
              </p>
            </div>

            <div className='process-step'>
              <div className='step-number'>3</div>
              <h3>Implementation</h3>
              <p>
                Expert implementation and deployment with full support from our
                partner network.
              </p>
            </div>

            <div className='process-step'>
              <div className='step-number'>4</div>
              <h3>Ongoing Support</h3>
              <p>
                Continuous support and maintenance with access to partner
                resources and expertise.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='cta-section'>
        <div className='container'>
          <h2>Ready to Leverage Our Partnerships?</h2>
          <p>
            Contact us to discuss how our strategic partnerships can benefit
            your organization and accelerate your digital transformation.
          </p>
          <Link to='/contact' className='btn btn-primary'>
            Get Started Today
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Partners
